<template>
  <div
    class="card-item air"
    style="width:50%;height: 100%;display: inline-block;"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.3)"
  >
    <div class="device-picker" style="right: auto;left: 20px;top: 12px;">
      土壤墒情
    </div>

    <div class="last-data">
      <div class="last-item">
        <div class="v" style="color: #009be9;">电导率</div>
        <div class="v">
          {{ last.e3 || '-' }}
        </div>
      </div>

      <div class="last-item">
        <div class="v" style="color: #009be9;">PH值</div>
        <div class="v" :style="`color: ${phColor(last.e4)}`">
          {{ last.e4 ? ` ${last.e4}` : '-' }}
        </div>
      </div>
    </div>

    <echart chartId="air-qua" :options="options" :height="height - 76"></echart>
  </div>
</template>

<script>
import mixin from '../mixin'
import Echart from '@/components/Chart'
import { list } from '@/service/meteorology'
import { subtract, add } from '@/utlis/date'
import sleep from '@/utlis/sleep'

export default {
  mixins: [mixin],
  components: { Echart },
  props: { code: String },
  data() {
    return {
      loadingCols: false, // 初始化列数据
      loading: false,
      data: [],
      last: {}
    }
  },
  computed: {
    dev() {
      return this.metes.find(m => m.id === this.deviceId)
    },
    deviceId() {
      if (this.code) {
        const dev = this.metes.find(m => m.key === this.code)
        return dev && dev.id
      } else {
        return ''
      }
    },
    options() {
      const keys = [
        { key: 'e1', type: 'line', name: '土壤温度' },
        { key: 'e2', type: 'line', name: '土壤湿度' },
        { key: 'e5', type: 'bar', name: '氮离子' },
        { key: 'e6', type: 'bar', name: '磷离子' },
        { key: 'e7', type: 'bar', name: '钾离子' }
      ]
      return {
        legend: { show: false },
        grid: {
          left: 20,
          right: 20,
          bottom: 12,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          splitLine: { show: false }
        },
        yAxis: [
          {
            type: 'value',
            splitLine: { show: false }
          },
          {
            type: 'value',
            splitLine: { show: false }
          }
        ],
        dataset: {
          dimensions: ['date'].concat(keys.map(c => c.key)),
          source: this.data
        },
        series: keys.map((k, idx) => ({
          type: k.type,
          name: k.name,
          yAxisIndex: idx < 2 ? 0 : 1
        }))
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getCols() {},
    async getData() {
      if (!this.deviceId) return
      this.loading = true
      const [{ data }, { data: last }] = await Promise.all([
        list({
          companyId: this.companyId,
          deviceId: this.deviceId,
          begin: subtract(undefined, 1, 'days', 'YYYY-MM-DD 00:00:00'),
          end: add(undefined, 1, 'days', 'YYYY-MM-DD 00:00:00'),
          type: 'day'
        }),
        list({
          companyId: this.companyId,
          deviceId: this.deviceId,
          type: 'last'
        }),
        sleep(1)
      ])
      this.last = last
      this.data = data
      this.loading = false
    },
    phColor(v) {
      return `rgb(${255 - ((v - 4) / 6) * 205}, ${255 -
        (Math.abs(v - 7) / 4) * 205}, ${255 - ((10 - v) / 6) * 205})`
    }
  },
  watch: {
    code() {
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.device-picker {
  position: relative !important;
  left: 0 !important;
  top: 0 !important;
  padding-left: 20px;
  padding-top: 8px;
  box-sizing: border-box;
}
.no-data {
  height: 100%;
}

.last-data {
  margin-top: 12px;
  height: 32px;
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid rgba(70, 103, 160, 0.9);
  border-top: 1px solid rgba(70, 103, 160, 0.9);
  box-sizing: border-box;
}
.last-item {
  flex: 1;
  display: flex;
  border-left: 1px solid rgba(70, 103, 160, 0.9);
  align-items: center;
  justify-content: center;
  &:last-child {
    border-right: 1px solid rgba(70, 103, 160, 0.9);
  }
  .v {
    display: inline-block;
    line-height: 32px;
    font-size: 1rem;
    &:first-child {
      margin-right: 8px;
    }
  }
}
</style>
